export const classifyOpt = {
  project: [{
    label: '外观',
    value: '外观'
  }, {
    label: '环境配套',
    value: '环境配套'
  }, {
    label: '鸟瞰图',
    value: '鸟瞰图'
  }, {
    label: '平面图',
    value: '平面图'
  }],
  building: [{
    label: '外观',
    value: '外观'
  }, {
    label: '大堂',
    value: '大堂'
  }, {
    label: '电梯间',
    value: '电梯间'
  }, {
    label: '走廊',
    value: '走廊'
  }, {
    label: '茶水间',
    value: '茶水间'
  }, {
    label: '洗手间',
    value: '洗手间'
  }, {
    label: '配套',
    value: '配套'
  }, {
    label: '其他',
    value: '其他'
  }],
  property: [{
    label: '前台',
    value: '前台'
  }, {
    label: '员工区',
    value: '员工区'
  }, {
    label: '经理室',
    value: '经理室'
  }, {
    label: '会议室',
    value: '会议室'
  }, {
    label: '洽谈室',
    value: '洽谈室'
  }, {
    label: '老板室',
    value: '老板室'
  }, {
    label: '茶室',
    value: '茶室'
  }, {
    label: '休闲区',
    value: '休闲区'
  }, {
    label: '外景',
    value: '外景'
  }, {
    label: '其他',
    value: '其他'
  }, {
    label: '平面图',
    value: '平面图'
  }, {
    label: '平面布局图',
    value: '平面布局图'
  }, {
    label: '定制装修效果',
    value: '定制装修效果'
  }, {
    label: '财务室',
    value: '财务室'
  }, {
    label: '娱乐室',
    value: '娱乐室'
  }, {
    label: '直播室',
    value: '直播室'
  }, {
    label: '电话间',
    value: '电话间'
  }, {
    label: '母婴室',
    value: '母婴室'
  }, {
    label: '机房',
    value: '机房'
  }],
  shop: [{
    label: '门头图',
    value: '门头图'
  }, {
    label: '室内图',
    value: '室内图'
  }]
};
export const lineRegExp = /^(?:0\d{2,3}-\d{7,8}|\+852-\d{8}|\+853-\d{8}|\+886-9\d{8})$/;
export const phoneRegExp = /^(?:(?:\+?86)?1[3-9]\d{9}|(?:\+?852)?(?:5|6|9)\d{7}|(?:\+?853)?6\d{7}|(?:\+?886)?09\d{8})$/;